$(document).ready(function () {
    window.openNav = function () {
        $("#myNav").css("width", "250px");
    };

    window.closeNav = function () {
        $("#myNav").css("width", "0%");
    };

    $(".header-dropdown-menu").hover(function () {
        openNav();
    });
    $("#myNav").on("mouseleave", function () {
        closeNav();
    });

    // 初期表示時にサービスを確認するメニューを展開
    $(".has-submenu > a").first().siblings("ul").show();

    $(".has-submenu > a").on("click", function(e) {
        e.preventDefault();
        const submenu = $(this).siblings("ul");
        submenu.stop().slideToggle(300);
    });

    // メニュー以外をクリックした時にサブメニューを閉じる
    $(document).on("click", function(e) {
        if (!$(e.target).closest('.has-submenu').length) {
            $(".submenu").stop().slideUp(300);
        }
    });

    $(document).on("click touchstart", function (e) {
        if (!$(e.target).closest("#myNav, .header-dropdown-menu").length) {
            closeNav();
        }
    });
});
